import { IGetAllControleServicosUseCase } from "../../../presentation/useCases/read/get_all_controle_servicos_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";
import { GetAllControleServicosDao, GetAllControleServicosRequest } from "../../../data/daos/read/get_all_controle_servicos";

/**
 * GetAllControleServicosUseCase
 */

export class GetAllControleServicosUseCase
  extends BasePaginatedUseCase<GetAllControleServicosDao>
  implements IGetAllControleServicosUseCase
{
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllControleServicos(modal: GetAllControleServicosRequest): Promise<void> {
    const response = await this.repository.getAllControleServicosList(modal);
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
